import { logger } from "./logger";

const MAX_LENGTH = 200;

export const spyOnActions = () => {
  require("mobx").spy((event: any) => {
    if (
      event.type === "action" &&
      !["mouseEnteredCalendarEntry", "mouseLeftCalendarEntry"].includes(event.name)
    ) {
      const args = [].slice
        .call(event.arguments)
        .map((arg: any) => {
          const json = JSON.stringify(arg, (k, v) => {
            try {
              JSON.stringify(v);
              return v;
            } catch (e) {
              return {};
            }
          });
          return json && json.length > MAX_LENGTH ? json.slice(0, MAX_LENGTH - 3) + "..." : json;
        })
        .join(", ");
      logger.debug(
        `%c Action ${event.name} with args: [${args}]`,
        "background: #222; color: #bada55"
      );
    }
  });
};
